import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpParamsBuilder } from './corrected-http-client';
import { HttpParameterCodecExtended } from './http-parameter-codec-extended';


@Injectable()
export class CorrectedHttpParamsBuilder extends HttpParamsBuilder {
  constructor(protected encoder: HttpParameterCodecExtended) {
    super();
  }

  fromClone(source: HttpParams): HttpParams {

    const sourceObj: { [param: string]: string[] } = {};
    source.keys().forEach(key => sourceObj[key] = source.getAll(key));

    return new HttpParams({ fromObject: sourceObj, encoder: this.encoder });
  }


  fromObject(source: { [param: string]: unknown; }): HttpParams {

    const sourceObj: { [param: string]: string | readonly string[] } = {};

    Object.keys(source).forEach(key => {
      const sourceValue = source[key];
      let sourceValueAsString: string | string[];

      if (Array.isArray(sourceValue))
        sourceValueAsString = sourceValue.map(v => this.encoder.valueToString(v));
      else
        sourceValueAsString = this.encoder.valueToString(sourceValue);

      sourceObj[key] = sourceValueAsString;
    });

    return new HttpParams({ fromObject: sourceObj, encoder: this.encoder });
  }
}
